import { Component, OnInit } from '@angular/core';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { select, Store } from '@ngrx/store';
import { GetCustomerProcedures } from '../../../lines/store/actions/customer-procedures.actions';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { CustomerProcedureInterface } from '../../../lines/models/customer-procedure.interface';
import { CustomerProcedureInterfaceState } from '../../../lines/store/state/customer-procedure.state';
import { SelectedProcedureInterfaceState } from '../../../shared/store/state/selected-procedure.state';
import { DisplayProcedureMessageService } from '../../../lines/services/display-procedure-message.service';
import { CustomerStorageService } from '../../services/customer-storage.service';
import moment from 'moment';
import { CustomerInterface } from '../../models/customer.interface';
import { MsisdnListInterfaceState } from '../../../lines/store/state/msisdn-list.state';
import { GetMsisdnList } from '../../../lines/store/actions/msidn-list.actions';

@Component({
    selector: 'app-account-management',
    templateUrl: './account-management.component.html',
    styleUrls: ['./account-management.component.css'],
    standalone: false
})
export class AccountManagementComponent implements OnInit {

  activeProceduresList: Array<CustomerProcedureInterface> = [];
  inProgressProceduresList: Array<CustomerProcedureInterface> = [];
  selectedProcedure: string = null;
  step: number;
  status: string;
  message: object;
  displayUpdatePassword: boolean;
  constHelper = ConstsHelper;

  constructor(
      private store: Store<any>,
      private customerStorage: CustomerStorageService,
      public displayProcedureMessageService: DisplayProcedureMessageService,
  ) {}

  ngOnInit() {
    this.step = 0;
    this.status = null;
    this.displayUpdatePassword = false;

    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER_PROCEDURES)).subscribe((response: CustomerProcedureInterfaceState) => {
      if (null !== response.customerProcedures) {
        this.activeProceduresList = [];
        this.inProgressProceduresList = [];
        const customer = this.customerStorage.getCustomer();
        for (const procedure of response.customerProcedures) {
          const localStorageBlockCreationCard = ConstsHelper.LOCAL_STORAGE_TEMPORARILY_BLOCK_CREATION_NEW_CARD + '_' + customer.id;
          if (localStorage.getItem(localStorageBlockCreationCard) && procedure.code === ConstsHelper.PROCEDURE_EXPIRATION_CB) {
            const data = JSON.parse(localStorage.getItem(localStorageBlockCreationCard));
            if (parseInt(moment(new Date()).subtract(30, 'minute').format('YYYYMMDDHHmm'), 10) < parseInt(data.date, 10)) {
              procedure.status = 'in_progress';
            } else {
              localStorage.removeItem(localStorageBlockCreationCard);
            }
          }
          switch (procedure.status) {
            case 'finished':
              if (this.checkProcedureVisibility(procedure.code, customer)) {
                this.activeProceduresList.push(procedure);
              }
              break;
            case 'wait_form':
              this.activeProceduresList.push(procedure);
              break;
            default:
              this.inProgressProceduresList.push(procedure);
              break;
          }
        }
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_SELECTED_PROCEDURE)).subscribe((response: SelectedProcedureInterfaceState) => {
      if (response.code != null) {
        this.selectedProcedure = response.code;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_MSISDN_LIST)).subscribe((response: MsisdnListInterfaceState) => {
      if (response.list instanceof Array && response.list.length > 0) {
        for (const msisdn of response.list) {
          if (msisdn.status.toLowerCase() === 'active') {
            this.displayUpdatePassword = true;
          }
        }
      }
    });

    this.store.dispatch(new GetMsisdnList());
    this.store.dispatch(new GetCustomerProcedures('account', null));
  }

  getProcedure(procedure: CustomerProcedureInterface) {
    this.step = procedure.nextStep;
    this.status = procedure.status;
    if (procedure.lastMessage) {
      this.message = procedure.lastMessage;
    }
    this.store.dispatch(new UpdateSelectedProcedure(procedure.code));
  }

  getInProgressProcedure(procedure: CustomerProcedureInterface) {
    this.step = procedure.nextStep;
    this.status = procedure.status;
    this.message = procedure.lastMessage;
    if (procedure.status === 'wait_form') {
      this.store.dispatch(new UpdateSelectedProcedure(procedure.code));
    } else {
      this.displayProcedureMessageService.displayInProgressMessage(procedure);
    }
  }

  private checkProcedureVisibility(procedureCode: string, customer: CustomerInterface) {
    if (
        (this.constHelper.PROCEDURE_GENERATE_SEPA_MANDATE === procedureCode && [null, ''].indexOf(customer.iban) !== -1) ||
        (this.constHelper.PROCEDURE_UPDATE_IBAN === procedureCode) ||
        (this.constHelper.PROCEDURE_EXPIRATION_CB === procedureCode) ||
        (this.constHelper.PROCEDURE_CUSTOMER_RGPD === procedureCode)
    ) {
      return false;
    } else if (this.constHelper.PROCEDURE_ACCOUNT_CONSOLIDATION === procedureCode && customer.recovery) {
      return false;
    } else {
      return !(this.constHelper.PROCEDURE_RESET_PASSWORD === procedureCode && !this.displayUpdatePassword);
    }
  }
}
